import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import { useSelector } from 'react-redux';

function CountdownTimer() {
    const [timer, setTimer] = useState('');

    const startTime = useSelector(state => state.cart.start_time);

    useEffect(() => {
        if (startTime == null) {
            return;
        }

        document.body.classList.add('has-timer');

        function poll() {
            let duration = 60 * 15;
            let diff = duration - (((Date.now() - startTime) / 1000) | 0);
            let minutes = (diff / 60) | 0;
            let seconds = (diff % 60) | 0;

            if (minutes <= 0) {
                minutes = 0;
            } else {
                minutes = minutes < 10 ? '0' + minutes : minutes;
            }

            if (minutes === 0 && seconds <= 0) {
                seconds = 0;
            } else {
                seconds = seconds < 10 ? '0' + seconds : seconds;
            }

            setTimer(`${minutes}:${seconds}`);
        }

        const interval = setInterval(poll, 1000);

        return () => {
            clearInterval(interval);

            document.body.classList.remove('has-timer');
        };
    }, [startTime]);

    if (startTime == null) {
        return null;
    }

    return (
        <div className="checkout__limit" style={{'display': 'block'}}>
            <i className="fas fa-clock"></i>
            <span>Din bokning är reserverad i</span>
            <strong>{timer}</strong>
            <span>min</span>
        </div>
    );
}

export default hot(module)(CountdownTimer);
